import { type ThemeName, tokens } from "./tokens";

export type ThemePreference = "system" | "light" | "dark";

/** Everything a component styles from: the resolved palette plus the theme-independent scales. */
function buildTheme(name: ThemeName) {
  return {
    name,
    color: tokens.color[name],
    onPrimary: tokens.color.onPrimary,
    brand: tokens.color.brand,
    shadow: tokens.shadow[name],
    font: tokens.font,
    fontSize: tokens.fontSize,
    lineHeight: tokens.lineHeight,
    letterSpacing: tokens.letterSpacing,
    space: tokens.space,
    radius: tokens.radius,
    borderWidth: tokens.borderWidth,
    size: tokens.size,
    breakpoint: tokens.breakpoint,
  } as const;
}

export type AppTheme = ReturnType<typeof buildTheme>;

/** One stable object per theme, so memoised styles can key on identity. */
export const themes: Record<ThemeName, AppTheme> = {
  light: buildTheme("light"),
  dark: buildTheme("dark"),
};

export function resolveTheme(
  preference: ThemePreference,
  deviceScheme: ThemeName | null,
): ThemeName {
  return preference === "system" ? (deviceScheme ?? "light") : preference;
}
